
import React, { useEffect, useState } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import { setLocalStoarge } from "../../common/allFunctions";
import Select from "react-select";

export default function CountryFilter({ onSelectCountry, reset, borderTrue ,state  }) {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState] = useState( 
    JSON.parse(localStorage.getItem("selectedState")) || null
  );


  useEffect(() => {
    if (selectedState?.value) {
      const localData = JSON.parse(localStorage.getItem(`countyList`+state) || "[]");
      
       const selectedStateLocal = state || selectedState?.label ;
      const filteredCountries = selectedStateLocal
        ? localData.filter((item) => item.stateID === selectedStateLocal)
        : localData;

      setCountries(filteredCountries);


      if (localData.length === 0) {
        getCountryByState(selectedStateLocal);
      } else {
        setSelectedCountry(""); // Reset selected county
      }
    } else {
      setCountries([]);
    }
  }, [selectedState]);
  useEffect(() => {
    if (reset) {
      setSelectedCountry("");
    }
  }, [reset]);

  const getCountryByState = (stateId) => {
    const queryParams = new URLSearchParams({ state_id: stateId });

    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_COUNTRY}?${queryParams}`
    )
      .then((response) => {
        if (response?.data?.data && Array.isArray(response.data.data)) {
          const filteredData = selectedState?.label
            ? response.data.data.filter(
                (item) => item.stateID === selectedState.label
              )
            : response.data.data;

          setCountries(filteredData);
          console.log("count", filteredData);
          localStorage.setItem(
            `countyList`+stateId,
            JSON.stringify(response.data.data)
          );
          setSelectedCountry(""); // Reset selection if new data is fetched
        }
      })
      .catch((error) => {
        console.log("County fetch error:", error?.message);
      });
  };

  const handleChange = (event) => {
    const country = event;
    setSelectedCountry(country);
    onSelectCountry(country.value);
  };

  const transformedCountries = countries.map((country) => ({
    value: country.countyName,
    label: country.countyName,
  }));

  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          borderTop: !borderTrue && "none",
          borderLeft: !borderTrue && "none",
          borderRight: !borderTrue && "none",
          boxShadow: borderTrue && "none",
          "&:hover": {
            borderColor: "#2684FF",
          },
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: "#a71e1e",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#6c757d",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          borderRadius: 0,
        }),
      }}
      options={transformedCountries}
      value={selectedCountry}
      onChange={handleChange}
      placeholder="COUNTY"
      isSearchable
    />
  );
}
